import { finance as financeApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
export const financeApiWithTags = financeApi.enhanceEndpoints({
  endpoints: {
    // ---- EkstreAI (Statement AI) ----
    uploadStatementAsync: { invalidatesTags: ['EkstreAI'] },
    getStatementsAsync: { providesTags: ['EkstreAI'] },
    getStatementDetailAsync: { providesTags: ['EkstreAI'] },
    parseEkstre: { invalidatesTags: ['EkstreAI'] },
    analyzeEkstre: { invalidatesTags: ['EkstreAI'] },
    getMonthlyCountsAsync: { providesTags: ['EkstreAI'] },
    getCategories: { providesTags: ['FinanceCategories'] },

    // ---- Currencies ----
    getAllCurrencies: { providesTags: ['Currencies'] },

    // ---- Funds ----
    getAllFunds: { providesTags: ['Funds'] },
    getFundAsync: { providesTags: ['Funds'] },

    // ---- Metals ----
    getAllMetals: { providesTags: ['Metals'] },
    getMetalAsync: { providesTags: ['Metals'] },

    // ---- Favorite Funds ----
    addFavoriteFund: { invalidatesTags: ['FavoriteFunds', 'Funds'] },
    deleteFavoriteFund: { invalidatesTags: ['FavoriteFunds', 'Funds'] },

    // ---- Favorite Metals ----
    addFavoriteMetal: { invalidatesTags: ['FavoriteMetals', 'Metals'] },
    deleteFavoriteMetal: { invalidatesTags: ['FavoriteMetals', 'Metals'] },
  },
});
